export default __webpack_public_path__ + "1fd934ee464d38d4fc680f2611891ea6.gif";